import { style } from 'typestyle';
import { mixinFont } from '../../../style.mixin';
import {
    COLOR_05,
    FONT_WEIGHT_BLACK,
    FONT_WEIGHT_BOLD,
    FONT_WEIGHT_REGULAR,
    MARGINS_PX
} from '../../../constants';

export const countryProfileDashboardContent1ClassName = style({
    flexShrink: 0,
    flexGrow: 0
});

export const countryProfileDashboardContent2ClassName = style({
    flexShrink: 1,
    flexGrow: 1
});

export const countryProfileDashboardTitleClassName = style({
    ...mixinFont(32, FONT_WEIGHT_BLACK, 34, COLOR_05)
});

export const countryProfileDashboardContentBoxClassName = style({
    height: '100%'
});

export const countryProfileDashboardSectionTitleClassName = style({
    ...mixinFont(16, FONT_WEIGHT_BLACK)
});

export const countryProfileDashboardSectionContentClassName = style({
    margin: `0 ${MARGINS_PX}px ${MARGINS_PX}px`
});

export const countryProfileDashboardDonutsWrapperClassName = style({
    width: '60% !important',
    flexBasis: '60%',
    flexShrink: '0 !important'
});

export const countryProfileDashboardImplementationTitleClassName = style({
    ...mixinFont(12, FONT_WEIGHT_BOLD)
});

export const countryProfileDashboardImplementationDescriptionClassName = style({
    ...mixinFont(12, FONT_WEIGHT_REGULAR),
    marginBottom: MARGINS_PX + 'px'
});

export const countryProfileDashboardQuotaTypeNameClassName = style({
    ...mixinFont(16, FONT_WEIGHT_BLACK, 20, COLOR_05),
    margin: `0 0 ${MARGINS_PX / 2}px 0`
});

export const countryProfileDashboardLegalProvisionsWrapperClassName = style({
    ...mixinFont(12, FONT_WEIGHT_REGULAR)
});
